import {
    PlanFinGroupDetail,
    PlanStageType,
    ProductPlan,
} from "tm-shared/types";

export const makePlans = (dirtyPlans: Record<string, PlanFinGroupDetail>) => {
    return Object.values(dirtyPlans)
        .flatMap(({ details }) => details)
        .reduce<Record<string, { type: ProductPlan; stage: PlanStageType }>>(
            (acc, product) => {
                acc[product.barcode] = {
                    type: product.type,
                    stage: product.stage,
                };

                return acc;
            },
            {},
        );
};
